// components
import DeleteAccountPage from '@karehero/llama/components/pages/DeleteAccount/DeleteAccount';

export const DeleteAccount = () => {
  return <DeleteAccountPage />;
};

export default DeleteAccount;
